export enum Color {
  ACCENT = '#FAC000',
  BLACK = '#000000',
  WHITE = '#FFFFFF',
  GRAY = '#9B9B9B',
  LIGHT_GRAY = '#F7F7F7',
  MEDIUM_GRAY = '#9E9E9E',
  DARK_GRAY = '#4A4A4A',
  RED = '#FF0000',
  LIGHT_RED = '#FF8A8A',
  GREEN_CHECK = '#0ABD04'
}
